import { Controller } from "@hotwired/stimulus"

// Opens/closes a native <dialog data-modal-target="dialog"> as a daisyUI modal.
// Use data-action="modal#open" / "modal#close" on the trigger buttons.
export default class extends Controller {
  static targets = ["dialog"]

  open(event) {
    event?.preventDefault()
    this.dialogTarget.showModal()
  }

  close(event) {
    event?.preventDefault()
    this.dialogTarget.close()
  }
}
